/// <amd-module name="Environments/Client/EnvironmentContracts" />
import { EnvironmentInstance, EnvironmentReference, EnvironmentResourceReference, EnvironmentResourceType, ProjectReference, TaskOrchestrationOwner, TaskResult } from "DistributedTask/Client/Contracts/TaskAgent";
import { IdentityRef } from "VSS/Platform/Contracts/WebApi";

import { CheckIssue } from "Checks/Client/Contracts/PipelinesChecks";
import { EnvironmentArtifactCommitRecord, EnvironmentCommitsRecord, EnvironmentPipelineRepositoryData } from "Environments/RemoteClients/Contracts/Traceability";
import { WorkItemType } from "Environments/RemoteClients/Contracts/WorkItemTracking";

export interface IEnvironmentDeploymentJobRecord
{
    environmentExecutionRecordId: number;
    resourceReference: EnvironmentResourceReference;
    definition: TaskOrchestrationOwner;
    environmentReference: EnvironmentReference;
    finishTime: Date;
    jobAttempt: number;
    jobName: string;
    owner: TaskOrchestrationOwner;
    planId: string;
    queueTime: Date;
    requestIdentifier: string;
    result: TaskResult;
    scopeId: string;
    serviceOwner: string;
    stageAttempt: number;
    stageName: string;
    startTime: Date;
}

export interface IEnvironmentDeploymentHistoryViewRecord
{
    environmentId: number;
    scopeId: string;
    planType: string;
    stageName: string,
    definition: TaskOrchestrationOwner;
    owner: TaskOrchestrationOwner;
    ownerSourceInfoMessage: string;
    jobs: IEnvironmentDeploymentJobRecord[];
}

export const enum IEnvironmentDeploymentJobStatus {
    Succeeded = 0,
    SucceededWithIssues = 1,
    Failed = 2,
    Canceled = 3,
    Inprogress = 4,
    NotStarted = 5
}

export interface IEnvironmentDeploymentHistoryResult {
    deploymentExecutionRecords: IEnvironmentDeploymentHistoryViewRecord[];
    continuationToken: number;
}

export interface IEnvironmentPageData {
    environment: EnvironmentInstance;
    environmentDeploymentHistory: IEnvironmentDeploymentHistoryResult;
}

export interface IEnvironmentsResult {
    environments: IEnvironmentObject[];
    continuationToken: string;
}

export interface IEnvironmentResult {
    environment: IEnvironmentObject;
}

export interface IEnvironmentResourceProviderData {
    providerDisplayString?: string;
}

export interface IEnvironmentResourceObject 
{
    id: number;
    name: string;
    type: EnvironmentResourceType;
    tags: string[];
    providerData?: IEnvironmentResourceProviderData;
    deploymentRecords?: IEnvironmentDeploymentJobRecord[];
}

export interface IEnvironmentObject
{
    createdBy: IdentityRef;
    createdOn: Date;
    description: string;
    id: number;
    lastModifiedBy: IdentityRef;
    lastModifiedOn: Date;
    name: string;
    resources: IEnvironmentResourceObject[];
    deploymentRecords?: IEnvironmentDeploymentJobRecord[];
    project: ProjectReference;
    issue?: CheckIssue
}

export enum EnvironmentJobStatus
{

    None = 0,
    Succeeded = 1,
    SucceededWithIssues = 2,
    Abandoned = 4,
    Canceled = 8,
    Failed = 16,
    Skipped = 32,
    InProgress = 64,
    All = Succeeded | SucceededWithIssues | Abandoned | Canceled | Failed | Skipped | InProgress
}

export interface IEnvironmentRunJobRecord
{
    jobId: string;
    jobName: string;
    resourceReference: EnvironmentResourceReference;
    result: TaskResult;
    startTime: Date;
    finishTime:  Date;
}

export interface IEnvironmentRunObject 
{
    environmentReference: EnvironmentReference;
    jobs: IEnvironmentRunJobRecord[]
}

export interface IEnvironmentRunsResponse 
{
    environmentRunObjects: IEnvironmentRunObject[];
}

export interface IWorkitemsResult {
    workitems: WorkItemRef[];
    icons: WorkItemType[];
}

export interface ICommitsResult {
    commits: EnvironmentCommitsRecord[],
    repo?: EnvironmentPipelineRepositoryData
}

export interface WorkItemRef {
    links?: any;
    currentState: string;
    id: string;
    title: string;
    type: string;
    createdOn: Date;
    assignedTo: any;
    url: string;
} 

export interface IEnvironmentArtifactCommitsResult {
    EnvironmentArtifactCommits: EnvironmentArtifactCommitRecord[]
}